module.exports = __webpack_public_path__ + "img/1F625.c78c6133.svg";